import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundengruppeServiceConfig = {
  name: "Kundengruppe",
  annotations: []
} as ServiceConfig;